import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { OrderAttributeDefinition } from '@app/api/models/order';
import { booleanBodyRender, TableColumn } from '@app/components/common/table';

export const useColumns = ({
  onEdit,
}: {
  onEdit: (attribute: OrderAttributeDefinition) => void;
}): TableColumn<OrderAttributeDefinition>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'name',
      label: 'Название',
      options: {
        filter: { type: 'text', name: 'name' },
        sort: true,
      },
    },
    {
      name: 'code',
      label: 'Код',
      options: {
        filter: { type: 'text', name: 'code' },
        sort: true,
      },
    },
    {
      name: 'data_type',
      label: 'Тип данных',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'is_required',
      label: 'Обязательный',
      options: {
        filter: false,
        sort: false,
        customBodyRender: booleanBodyRender(),
      },
    },
    {
      name: 'distributor_id',
      label: 'Дистрибьютор ID',
      options: {
        filter: { type: 'text', name: 'distributor_id' },
        sort: true,
        customBodyRender: (value: number | null) => <span>{value ?? '—'}</span>,
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => (
          <Flex gap={2}>
            <IconButton
              name="edit"
              aria-label="edit"
              size="sm"
              onClick={() => onEdit(rowData as OrderAttributeDefinition)}
            >
              <MdEdit />
            </IconButton>
          </Flex>
        ),
      },
    },
  ];
};
